import { useState, useEffect } from "react";
import { sellerService } from "@b2b/services";

export const useSellerProfile = (sellerId?: string) => {
  const [currentBanner, setCurrentBanner] = useState(0);
  const [storefrontData, setStorefrontData] = useState<any>(null);
  // Start loading when a seller id is present to avoid empty→spinner flicker.
  const [loading, setLoading] = useState(() => Boolean(sellerId));
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!sellerId) {
      setStorefrontData(null);
      setLoading(false);
      setError(null);
      return;
    }

    let active = true;
    const fetchStorefrontData = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await sellerService.getPublicStorefront(sellerId);
        if (!active) return;
        setStorefrontData(data);
      } catch (err: any) {
        if (!active) return;
        console.error("Failed to fetch storefront data:", err);
        setError(err.message || "Failed to load storefront");
        setStorefrontData(null);
      } finally {
        if (active) setLoading(false);
      }
    };

    void fetchStorefrontData();
    return () => {
      active = false;
    };
  }, [sellerId]);

  return {
    currentBanner,
    setCurrentBanner,
    storefrontData,
    loading,
    error,
  };
};
